import React from 'react';
export function Logo({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`flex items-center gap-2 sm:gap-3 ${className}`} aria-label="Author Leverage" data-id="element-279" data-mp="8t38tvsza2vl">
      <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/4wv71qfbbbwbngbvre9mbk/44613e2b-90fb-4116-b3c8-797cf4f5a5ea/author-mark.png" alt="" aria-hidden="true" className="h-8 w-8 shrink-0 object-contain sm:h-9 sm:w-9" width={36} height={36} decoding="async" data-id="element-280" data-mp="3q9kyos1rcqj7" />
      {/* Wordmark needs ~180px; hide below 360 so mark + short CTA fit at 320 */}
      <span className="hidden whitespace-nowrap font-serif text-xl font-semibold tracking-tight text-navy min-[360px]:inline sm:text-2xl" aria-hidden="true" data-id="element-281" data-mp="rpuw0gbn524x">
        Author Leverage
      </span>
    </div>;
}